<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'SIGNUP.TITLE' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <img src="assets/images/logo.png" alt="EZ Knews Logo" id="logo" />
  <div class="login-inputs">
    <ion-input color="primary" [(ngModel)]="displayName" placeholder="{{ 'SIGNUP.FULL_NAME_PLACEHOLDER' | translate }}"></ion-input>
    <ion-input color="primary" [(ngModel)]="email" type="email" placeholder="{{ 'SIGNUP.EMAIL_PLACEHOLDER' | translate }}"></ion-input>
    <ion-input color="primary" [(ngModel)]="password" type="password" placeholder="{{ 'SIGNUP.PASSWORD_PLACEHOLDER' | translate }}"></ion-input>
    <ion-input color="primary" [(ngModel)]="confirmPassword" type="password" placeholder="{{ 'SIGNUP.CONFIRM_PASSWORD_PLACEHOLDER' | translate }}"></ion-input>
  </div>
  <div class="login-buttons">
    <ion-button expand="block" (click)="signUp()">
      {{ 'SIGNUP.SIGNUP_BUTTON' | translate }}
      <ion-icon slot="start" name="log-in-outline"></ion-icon>
    </ion-button>
    <ion-button expand="block" color="danger" (click)="signUpWithGoogle()">
      <ion-icon slot="start" name="logo-google"></ion-icon>
      {{ 'SIGNUP.GOOGLE_BUTTON' | translate }}
    </ion-button>
    <ion-button *ngIf="isNative" expand="block" color="dark" (click)="signUpWithApple()">
      <ion-icon slot="start" name="logo-apple"></ion-icon>
      {{ 'SIGNUP.APPLE_BUTTON' | translate }}
    </ion-button>
    <ion-button *ngIf="!temporary" id="guest-login" expand="block" (click)="anonSignUp()">
      {{ 'SIGNUP.CONTINUE_AS_GUEST' | translate }}
      <ion-icon color="red" slot="start" name="rocket-outline"></ion-icon>
    </ion-button>
  </div>
  <p *ngIf="errorMessage" class="error">{{ errorMessage }}</p>

  <p>
    {{ 'SIGNUP.ALREADY_HAVE_ACCOUNT' | translate }} <a (click)="goToLogin()">{{ 'SIGNUP.LOGIN' | translate }}</a>
  </p>
</ion-content>